import Cookies from 'js-cookie';

export function initDumbleData() {
	let sps_ud = Cookies.get('SPS_UD');

	window.dumbleData = {
		omniture: {
			page: {
				pageInfo: {
					domain: document.domain,
					title: '',
					isError: false,
					pageType: ''
				}
			},
			siteInfo: {
				environment: process.env.REACT_APP_ENV,
				audience: 'teacher',
				language: 'en',
				name: 'BookWizard'
			},
			user: {
				loginStatus: sps_ud ? true : false,
				profile: {
					userType: '',
					SPSID: sps_ud ? sps_ud.split('|')[0] : "",
					grade: []
				}
			},
			cart: {
				itemsCount: 0,
				price: {
					basePrice: 0,
					currency: 'USD'
				}
			},
			cartItems: [],
			basketId: '',
			results: {
				totalNum: '',
				facets: [],
				sort: ''
			},
			search: {
				input: '',
				keyWord: '',
				numResults: 0,
				sort: '',
				type: ''
			},
			product: {
				author: '',
				format: '',
				guidedReadingLevel: '',
				highGrade: '',
				lowGrade: '',
				productID: '',
				title: '',
				listPrice: 0,
				displayPrice: 0
			},
			wishlist: {
				author: '',
				format: '',
				guidedReadingLevel: '',
				highGrade: '',
				lowGrade: '',
				productID: '',
				title: '',
				listPrice: 0,
				displayPrice: 0
			}
		}
	};
}

export function setPageType(pageType) {
	window.dumbleData.omniture.page.pageInfo.pageType = pageType;

	if (!pageType.includes("Results")) {
		removeSearchAndResults();
	} else if (!window.dumbleData.omniture.hasOwnProperty('search') && pageType.includes("Results")) {
		addSearchAndResults();
	}
}

export function setTitle(title) {
	window.dumbleData.omniture.page.pageInfo.title = title;
}

/** Runs the _satellite.track function to indicate a new
 *  page has loaded, runs on all book wizard pages (landing, discover, results, etc.)
 */
export function trackPageLoad() {
	window._satellite.track('BookWizard:PageLoad');
}

export function trackAddToCart() {
	window._satellite.track('BookWizard:AddToCart');
}

export function trackAddToWishlist() {
	window._satellite.track('BookWizard:AddToWishlist');
}

export function trackHomepageSearch() {
	window._satellite.track('BookWizard:Homepage_Search');
}

export function trackDiscoverResults() {
	window._satellite.track('BookWizard:Discover_Results');
}

export function trackResultspageSearch() {
	window._satellite.track('BookWizard:General_Search');
}

/** Updates the data layer and makes a satellite call whenever a 
 *  book-a-like button is clicked
 */
export function trackBookALikeSearch(resultsLength, bookTitle) {
	let ddResults = window.dumbleData.omniture.results
	ddResults.totalNum = resultsLength
	ddResults.facets = ["No Filters"]
	ddResults.sort = "relevance"

	let ddSearch = window.dumbleData.omniture.search
	ddSearch.input = ""
	ddSearch.keyWord = bookTitle
	ddSearch.numResults = resultsLength
	ddSearch.sort = "relevance"
	ddSearch.type = "book-a-like"

	window._satellite.track('BookWizard:Bookalike_Search')
}

export function setUserType(userType) {
	window.dumbleData.omniture.user.profile.userType = userType;
}

export function setGrade(gradeBand) {
	window.dumbleData.omniture.user.profile.grade = gradeBand;
}

export function setCartInfo(info) {
	window.dumbleData.omniture.cart.itemsCount = info.totalCartItems;
	window.dumbleData.omniture.cart.price.basePrice = info.orderSubTotal;
	window.dumbleData.omniture.basketId = (info.totalCartItems > 0) ? info.basketID : '';

	window.dumbleData.omniture.cartItems = [];

	info.cartItems.forEach((item, itemIndex) => {
		let element = {};
		element.productId = item.orderItemId;
		element.price = item.yourPrice;
		element.salesPrice = item.listPrice;
		element.quantity = item.qty;
		element.producType = item.productType;
		window.dumbleData.omniture.cartItems.push({ [`item${itemIndex}`]: element });
	});
	
}

export function setProductInfo(info,category) {
	window.dumbleData.omniture[category].author = info.author;
	window.dumbleData.omniture[category].format = info.format;
	window.dumbleData.omniture[category].guidedReadingLevel = info.guidedReadingLevel;
	window.dumbleData.omniture[category].lowGrade = info.grades.split("–")[0];
	window.dumbleData.omniture[category].highGrade = info.grades.split("–")[1];
	window.dumbleData.omniture[category].productID = info.isbn;
	window.dumbleData.omniture[category].displayPrice = parseFloat(info.displayPrice.toFixed(2));
	window.dumbleData.omniture[category].title = info.title;
	window.dumbleData.omniture[category].listPrice = parseFloat(info.listPrice.toFixed(2));
}

export function setResults(data, handleQuery) {
	window.dumbleData.omniture.results.totalNum = data.response.total_num_results;
	window.dumbleData.omniture.results.facets = [];
	window.dumbleData.omniture.results.sort = data.request.sort_by
	
	if (typeof handleQuery === 'string') {
		window.dumbleData.omniture.results.facets.push("No Filters");
	}
	else{
		for (let i = 0; i <= 5; i++) {
			if (i === 1 && handleQuery[0] === 'guidedReadingLevel') {
				window.dumbleData.omniture.results.facets = window.dumbleData.omniture.results.facets.concat(
					formatGuidedReadingValue(handleQuery[i].split('-')[0]) + '-' + formatGuidedReadingValue(handleQuery[i].split('-')[1])
				);
			} else if(handleQuery[i] !== '' && handleQuery[i] !== '-') {
				window.dumbleData.omniture.results.facets = window.dumbleData.omniture.results.facets.concat(handleQuery[i]);
			}
		}
	}

	setNumResultsAndSort(data);
}

/** Sets the dumbleData property search.type */
export function setSearchType(type) {
	window.dumbleData.omniture.search.type = type
}

export function setSearchTypeInputKeyword(searchType, searchTerm, typedTerm = 0){
	if (searchType === 'user-entered') {
		window.dumbleData.omniture.search.type = searchType;
		window.dumbleData.omniture.search.input = searchTerm;    
		window.dumbleData.omniture.search.keyWord = searchTerm;  
	} else {
		window.dumbleData.omniture.search.type = searchType;
		window.dumbleData.omniture.search.input = typedTerm;    
		window.dumbleData.omniture.search.keyWord = searchTerm;
	}
}

function setNumResultsAndSort(data){
	window.dumbleData.omniture.search.numResults = data.response.total_num_results;
	window.dumbleData.omniture.search.sort = data.request.sort_by;
}

function removeSearchAndResults() {
	delete window.dumbleData.omniture.results;
	delete window.dumbleData.omniture.search;
}

export function addSearchAndResults() {
	window.dumbleData.omniture.results = { totalNum: '', facets: [], sort: '' };
	window.dumbleData.omniture.search = { input: '', keyWord: '', numResults: 0, sort: '', type: '' };
}

function formatGuidedReadingValue(value) {
	const A = 'A'.charCodeAt(0);
	if (value === '27')
		{ return 'Z+'; }
	return String.fromCharCode(A + (value - 1));
}